export const getDiscontinuationStatusColor = (status: string): string => {
    if (status === "soc") {
        return "#285172";
    } else {
        return "#ff1e00";
    }
};

export const getDiscontinuationStatusIcon = (
    status: string,
    type: string,
    extendedSupport: boolean
): string => {
    if (status === "soc") {
        if (type === "machine") {
            return "cog-crossed";
        } else if (type === "equipment") {
            return "wrench-crossed";
        }
    } else if (status === "sod") {
        if (type === "machine") {
            return extendedSupport ? "cog-crossed-document" : "cog-crossed";
        } else if (type === "equipment") {
            return extendedSupport
                ? "wrench-crossed-document"
                : "wrench-crossed";
        }
    }

    return "";
};
